// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"s3-z"};